import { Calendar, Trophy } from 'lucide-react';
import StatusBadge from './status-badge';
import type { Tournament } from '@repo/shared-types';

interface TournamentCardProps {
  tournament: Tournament;
}

export const TournamentCard = ({ tournament }: TournamentCardProps) => {
  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm overflow-hidden">
      <div className="flex flex-col gap-4">
        <div className="flex flex-row sm:flex-col justify-between gap-1">
          <div className="text-lg font-medium flex justify-between items-center gap-2">
            {tournament.name}
          </div>
          <div>
            <StatusBadge status={tournament.status} />
          </div>
        </div>
        <div className="text-xs flex items-center gap-2">
          <Calendar className="w-4 h-4" />
          {tournament.startDate} - {tournament.endDate}
        </div>
        <div className="flex gap-2 text-sm">
          {tournament.categories.length > 0 && (
            <>
              <Trophy className="w-4 h-4" />
              <div className="flex flex-wrap items-center gap-2">
                {tournament.categories.map((category) => (
                  <div key={category.id} className="bg-gray-100 rounded-full px-2 py-1 text-xs">
                    {category.name}
                  </div>
                ))}
              </div>
            </>
          )}
          {tournament.categories.length <= 0 && (
            <div className="text-sm flex items-center gap-2">
              <Trophy className="w-4 h-4" />
              <div className="bg-gray-100 rounded-full px-2 py-1 text-xs text-center">
                Sin categorías
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
